module.exports = __webpack_public_path__ + "img/menu-sendmedia.d9cfb781.png";